import { useSiloWeb3 } from '@silo/web3';
import posthog from 'posthog-js';
import { getAreAllAssetsCollateral } from 'queries/decoratedSilo';
import { FC } from 'react';
import { ActionPanels } from '../common/ActionForm/ActionForm';
import { PulsePanel } from '../common/PulsePanel';
import { useThisDecoratedSilo } from '../silo';
import { BorrowForm, DoBorrow } from './BorrowForm';
import { BorrowingDisabled } from './BorrowingDisabled';
import { ProtocolInstance } from '@silo/types';

type BorrowPanelState =
  | { tag: 'noDeposits'; protocolInstance: ProtocolInstance }
  | { tag: 'disabled' }
  | { tag: 'loading' }
  // TODO: look into using React suspense for these values
  | { tag: 'loaded'; protocolInstance: ProtocolInstance };
// | { tag: 'frozen' };

const useBorrowPanelState = (): BorrowPanelState => {
  const decoratedSilo = useThisDecoratedSilo();
  const { account, protocolInstance, isNotConnected } = useSiloWeb3();

  if (protocolInstance === undefined) return { tag: 'loading' };

  if (isNotConnected) {
    return { tag: 'noDeposits', protocolInstance };
  }

  if (!decoratedSilo.hasPosition) {
    return { tag: 'noDeposits', protocolInstance };
  }

  if (getAreAllAssetsCollateral(decoratedSilo)) return { tag: 'disabled' };

  posthog.identify(account);
  return { tag: 'loaded', protocolInstance };
};

export interface BorrowPanelProps {
  doBorrow: DoBorrow;
}

export const BorrowPanel: FC<BorrowPanelProps> = ({ doBorrow }) => {
  const borrowPanelState = useBorrowPanelState();

  switch (borrowPanelState.tag) {
    case 'loading':
    default:
      return <PulsePanel />;
    case 'noDeposits': {
      const { protocolInstance } = borrowPanelState;
      return <BorrowForm protocolInstance={protocolInstance} noDeposits={true} />;
    }
    case 'disabled':
      return <ActionPanels panels={[<BorrowingDisabled />]} />;
    case 'loaded': {
      const { protocolInstance } = borrowPanelState;
      return <BorrowForm protocolInstance={protocolInstance} doBorrow={doBorrow} />;
    }
  }
};
